module.exports = __webpack_public_path__ + "img/TRX.88c23616.svg";